@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(-2_095_398_233)
internal val Res.string.quiz_preposizione_dr_1_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_1_opt4", "quiz_preposizione_dr_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225208, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222532, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224229, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214020, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208796, 43),
      ))
    }

@delegate:ResourceContentHash(1_709_908_642)
internal val Res.string.quiz_preposizione_dr_2: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_2", "quiz_preposizione_dr_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225731, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223115, 122),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224772, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214579, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209295, 110),
      ))
    }

@delegate:ResourceContentHash(-1_347_248_283)
internal val Res.string.quiz_preposizione_dr_2_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_2_opt1", "quiz_preposizione_dr_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225367, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222715, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224404, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214199, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 208963, 83),
      ))
    }

@delegate:ResourceContentHash(1_368_567_242)
internal val Res.string.quiz_preposizione_dr_2_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_2_opt2", "quiz_preposizione_dr_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225463, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222819, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224500, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214299, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209047, 75),
      ))
    }

@delegate:ResourceContentHash(-1_301_303_044)
internal val Res.string.quiz_preposizione_dr_2_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_2_opt3", "quiz_preposizione_dr_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225551, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 222915, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224584, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214395, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209123, 83),
      ))
    }

@delegate:ResourceContentHash(1_576_646_313)
internal val Res.string.quiz_preposizione_dr_2_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_2_opt4", "quiz_preposizione_dr_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225639, 91),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223019, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224684, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214491, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209207, 87),
      ))
    }

@delegate:ResourceContentHash(-1_775_631_020)
internal val Res.string.quiz_preposizione_dr_3: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_3", "quiz_preposizione_dr_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226186, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223562, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225219, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215010, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209718, 102),
      ))
    }

@delegate:ResourceContentHash(-1_928_910_140)
internal val Res.string.quiz_preposizione_dr_3_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_3_opt1", "quiz_preposizione_dr_3_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225858, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223238, 103),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224887, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214694, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209406, 99),
      ))
    }

@delegate:ResourceContentHash(-1_406_823_030)
internal val Res.string.quiz_preposizione_dr_3_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_3_opt2", "quiz_preposizione_dr_3_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 225962, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223342, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 224999, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214794, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209506, 71),
      ))
    }

@delegate:ResourceContentHash(-735_433_540)
internal val Res.string.quiz_preposizione_dr_3_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_3_opt3", "quiz_preposizione_dr_3_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226038, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223414, 71),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225071, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214870, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209578, 63),
      ))
    }

@delegate:ResourceContentHash(34_113_669)
internal val Res.string.quiz_preposizione_dr_3_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_3_opt4", "quiz_preposizione_dr_3_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226110, 75),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223486, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225143, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 214938, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209642, 75),
      ))
    }

@delegate:ResourceContentHash(499_775_388)
internal val Res.string.quiz_preposizione_dr_4: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_4", "quiz_preposizione_dr_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226629, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224049, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225706, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215481, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210149, 126),
      ))
    }

@delegate:ResourceContentHash(-1_410_953_582)
internal val Res.string.quiz_preposizione_dr_4_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_4_opt1", "quiz_preposizione_dr_4_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226289, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223681, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225342, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215125, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209821, 91),
      ))
    }

@delegate:ResourceContentHash(1_436_462_811)
internal val Res.string.quiz_preposizione_dr_4_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_4_opt2", "quiz_preposizione_dr_4_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226377, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223777, 91),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225438, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215229, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209913, 83),
      ))
    }

@delegate:ResourceContentHash(-2_018_466_184)
internal val Res.string.quiz_preposizione_dr_4_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_4_opt3", "quiz_preposizione_dr_4_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226481, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223869, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225542, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215317, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 209997, 83),
      ))
    }

@delegate:ResourceContentHash(-395_147_372)
internal val Res.string.quiz_preposizione_dr_4_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_dr_4_opt4", "quiz_preposizione_dr_4_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226561, 67),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 223965, 83),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225634, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215397, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210081, 67),
      ))
    }

@delegate:ResourceContentHash(-1_818_258_566)
internal val Res.string.quiz_preposizione_hr_1: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_1", "quiz_preposizione_hr_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227076, 162),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224456, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226145, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215896, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210576, 158),
      ))
    }

@delegate:ResourceContentHash(-1_657_624_923)
internal val Res.string.quiz_preposizione_hr_1_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_1_opt1", "quiz_preposizione_hr_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226772, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224180, 75),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225849, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215616, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210276, 83),
      ))
    }

@delegate:ResourceContentHash(-1_572_380_949)
internal val Res.string.quiz_preposizione_hr_1_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_1_opt2", "quiz_preposizione_hr_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226860, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224256, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 225929, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215696, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210360, 79),
      ))
    }

@delegate:ResourceContentHash(911_712_891)
internal val Res.string.quiz_preposizione_hr_1_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_1_opt3", "quiz_preposizione_hr_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 226940, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224336, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226017, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215776, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210440, 71),
      ))
    }

@delegate:ResourceContentHash(-474_742_080)
internal val Res.string.quiz_preposizione_hr_1_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_1_opt4", "quiz_preposizione_hr_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227012, 63),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224400, 55),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226085, 59),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 215840, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210512, 63),
      ))
    }

@delegate:ResourceContentHash(-2_107_332_996)
internal val Res.string.quiz_preposizione_hr_2: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_2", "quiz_preposizione_hr_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227471, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224851, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226596, 178),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216303, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211003, 158),
      ))
    }

@delegate:ResourceContentHash(-942_458_656)
internal val Res.string.quiz_preposizione_hr_2_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_2_opt1", "quiz_preposizione_hr_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227239, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224599, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226288, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216039, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210735, 71),
      ))
    }

@delegate:ResourceContentHash(690_817_076)
internal val Res.string.quiz_preposizione_hr_2_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_2_opt2", "quiz_preposizione_hr_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227295, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224663, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226368, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216107, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210807, 67),
      ))
    }

@delegate:ResourceContentHash(1_980_427_326)
internal val Res.string.quiz_preposizione_hr_2_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_2_opt3", "quiz_preposizione_hr_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227351, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224727, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226456, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216171, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210875, 63),
      ))
    }

@delegate:ResourceContentHash(-244_439_893)
internal val Res.string.quiz_preposizione_hr_2_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_2_opt4", "quiz_preposizione_hr_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227411, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 224787, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226528, 67),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216235, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 210939, 63),
      ))
    }

@delegate:ResourceContentHash(414_129_852)
internal val Res.string.quiz_preposizione_hr_3: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_3", "quiz_preposizione_hr_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228010, 102),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225330, 106),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227119, 110),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216770, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211490, 110),
      ))
    }

@delegate:ResourceContentHash(-1_332_389_878)
internal val Res.string.quiz_preposizione_hr_3_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_3_opt1", "quiz_preposizione_hr_3_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227654, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225026, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226775, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216478, 79),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211162, 87),
      ))
    }

@delegate:ResourceContentHash(-1_073_415_588)
internal val Res.string.quiz_preposizione_hr_3_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_3_opt2", "quiz_preposizione_hr_3_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227758, 79),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225106, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226867, 87),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216558, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211250, 83),
      ))
    }

@delegate:ResourceContentHash(1_755_919_041)
internal val Res.string.quiz_preposizione_hr_3_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_3_opt3", "quiz_preposizione_hr_3_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227838, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225170, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 226955, 83),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216626, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211334, 75),
      ))
    }

@delegate:ResourceContentHash(1_818_653_206)
internal val Res.string.quiz_preposizione_hr_3_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_3_opt4", "quiz_preposizione_hr_3_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 227926, 83),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225250, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227039, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216702, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211410, 79),
      ))
    }

@delegate:ResourceContentHash(455_161_821)
internal val Res.string.quiz_preposizione_hr_4: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_4", "quiz_preposizione_hr_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228377, 142),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225709, 134),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227534, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217129, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211865, 126),
      ))
    }

@delegate:ResourceContentHash(-78_125_721)
internal val Res.string.quiz_preposizione_hr_4_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_4_opt1", "quiz_preposizione_hr_4_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228113, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225437, 95),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227230, 99),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216873, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211601, 91),
      ))
    }

@delegate:ResourceContentHash(-902_333_559)
internal val Res.string.quiz_preposizione_hr_4_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_4_opt2", "quiz_preposizione_hr_4_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228213, 47),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225533, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227330, 55),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 216957, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211693, 51),
      ))
    }

@delegate:ResourceContentHash(2_134_806_766)
internal val Res.string.quiz_preposizione_hr_4_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_4_opt3", "quiz_preposizione_hr_4_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228261, 59),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225585, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227386, 71),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217009, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211745, 59),
      ))
    }

@delegate:ResourceContentHash(815_312_459)
internal val Res.string.quiz_preposizione_hr_4_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_hr_4_opt4", "quiz_preposizione_hr_4_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228321, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225649, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227458, 75),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217069, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211805, 59),
      ))
    }

@delegate:ResourceContentHash(-994_812_047)
internal val Res.string.quiz_preposizione_m_1: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_1", "quiz_preposizione_m_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228520, 145),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225844, 129),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227677, 121),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217264, 117),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 211992, 121),
      ))
    }

@delegate:ResourceContentHash(-1_442_266_519)
internal val Res.string.quiz_preposizione_m_2: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_2", "quiz_preposizione_m_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228666, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 225974, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227799, 117),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217382, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212114, 97),
      ))
    }

@delegate:ResourceContentHash(-1_694_673_756)
internal val Res.string.quiz_preposizione_m_3: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_3", "quiz_preposizione_m_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228768, 149),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226080, 141),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 227917, 125),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217480, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212212, 133),
      ))
    }

@delegate:ResourceContentHash(1_131_419_232)
internal val Res.string.quiz_preposizione_m_locativa_1: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_1", "quiz_preposizione_m_locativa_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229398, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226698, 162),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218086, 158),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212834, 146),
      ))
    }

@delegate:ResourceContentHash(319_763_272)
internal val Res.string.quiz_preposizione_m_locativa_1_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_1_opt1", "quiz_preposizione_m_locativa_1_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 228918, 147),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226222, 135),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217630, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212346, 151),
      ))
    }

@delegate:ResourceContentHash(-255_535_733)
internal val Res.string.quiz_preposizione_m_locativa_1_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_1_opt2", "quiz_preposizione_m_locativa_1_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229066, 99),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226358, 111),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217762, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212498, 103),
      ))
    }

@delegate:ResourceContentHash(77_177_522)
internal val Res.string.quiz_preposizione_m_locativa_1_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_1_opt3", "quiz_preposizione_m_locativa_1_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229166, 111),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226470, 107),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217862, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212602, 115),
      ))
    }

@delegate:ResourceContentHash(-1_126_084_807)
internal val Res.string.quiz_preposizione_m_locativa_1_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_1_opt4", "quiz_preposizione_m_locativa_1_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229278, 119),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226578, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 217970, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212718, 115),
      ))
    }

@delegate:ResourceContentHash(-953_215_746)
internal val Res.string.quiz_preposizione_m_locativa_2: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_2", "quiz_preposizione_m_locativa_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229949, 190),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227273, 174),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218645, 174),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213377, 182),
      ))
    }

@delegate:ResourceContentHash(1_479_169_561)
internal val Res.string.quiz_preposizione_m_locativa_2_opt1: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_2_opt1", "quiz_preposizione_m_locativa_2_opt1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229553, 107),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226861, 119),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218245, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 212981, 107),
      ))
    }

@delegate:ResourceContentHash(1_742_815_795)
internal val Res.string.quiz_preposizione_m_locativa_2_opt2: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_2_opt2", "quiz_preposizione_m_locativa_2_opt2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229661, 95),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 226981, 103),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218349, 91),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213089, 99),
      ))
    }

@delegate:ResourceContentHash(-560_796_519)
internal val Res.string.quiz_preposizione_m_locativa_2_opt3: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_2_opt3", "quiz_preposizione_m_locativa_2_opt3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229757, 87),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227085, 91),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218441, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213189, 87),
      ))
    }

@delegate:ResourceContentHash(-664_031_828)
internal val Res.string.quiz_preposizione_m_locativa_2_opt4: StringResource by lazy {
      StringResource("string:quiz_preposizione_m_locativa_2_opt4", "quiz_preposizione_m_locativa_2_opt4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 229845, 103),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227177, 95),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218537, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213277, 99),
      ))
    }

@delegate:ResourceContentHash(-1_344_673_338)
internal val Res.string.quiz_ripasso_cosa_significa_gero: StringResource by lazy {
      StringResource("string:quiz_ripasso_cosa_significa_gero", "quiz_ripasso_cosa_significa_gero", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230140, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227448, 88),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228043, 80),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218820, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213560, 84),
      ))
    }

@delegate:ResourceContentHash(1_229_503_371)
internal val Res.string.quiz_ripasso_quale_gero_significa: StringResource by lazy {
      StringResource("string:quiz_ripasso_quale_gero_significa", "quiz_ripasso_quale_gero_significa", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230225, 101),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227537, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228124, 101),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 218909, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213645, 97),
      ))
    }

@delegate:ResourceContentHash(-47_755_228)
internal val Res.string.quiz_ripasso_significato: StringResource by lazy {
      StringResource("string:quiz_ripasso_significato", "quiz_ripasso_significato", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230327, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227643, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228226, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219011, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213743, 52),
      ))
    }

@delegate:ResourceContentHash(-415_051_805)
internal val Res.string.quiz_ripasso_traslitterazione: StringResource by lazy {
      StringResource("string:quiz_ripasso_traslitterazione", "quiz_ripasso_traslitterazione", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230380, 65),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227700, 69),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228287, 69),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219068, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213796, 65),
      ))
    }

@delegate:ResourceContentHash(140_077_602)
internal val Res.string.quiz_sdm_f_intro_1: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_1", "quiz_sdm_f_intro_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230446, 134),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227770, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228357, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219138, 138),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213862, 134),
      ))
    }

@delegate:ResourceContentHash(423_853_989)
internal val Res.string.quiz_sdm_f_intro_2: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_2", "quiz_sdm_f_intro_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230581, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 227909, 102),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228496, 98),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219277, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 213997, 98),
      ))
    }

@delegate:ResourceContentHash(1_257_654_331)
internal val Res.string.quiz_sdm_f_intro_3: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_3", "quiz_sdm_f_intro_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230688, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228012, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228595, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219380, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214096, 110),
      ))
    }

@delegate:ResourceContentHash(347_902_471)
internal val Res.string.quiz_sdm_f_intro_4: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_4", "quiz_sdm_f_intro_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230795, 106),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228131, 110),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228710, 114),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219495, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214207, 102),
      ))
    }

@delegate:ResourceContentHash(-1_320_857_624)
internal val Res.string.quiz_sdm_f_intro_5: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_5", "quiz_sdm_f_intro_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 230902, 126),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228242, 118),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228825, 122),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219602, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214310, 106),
      ))
    }

@delegate:ResourceContentHash(707_594_648)
internal val Res.string.quiz_sdm_f_intro_6: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_6", "quiz_sdm_f_intro_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231029, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228361, 142),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 228948, 142),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219721, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214417, 134),
      ))
    }

@delegate:ResourceContentHash(-1_365_273_923)
internal val Res.string.quiz_sdm_f_intro_7: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_7", "quiz_sdm_f_intro_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231180, 146),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228504, 126),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229091, 146),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219856, 142),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214552, 126),
      ))
    }

@delegate:ResourceContentHash(895_884_767)
internal val Res.string.quiz_sdm_f_intro_8: StringResource by lazy {
      StringResource("string:quiz_sdm_f_intro_8", "quiz_sdm_f_intro_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231327, 166),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228631, 138),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229238, 166),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 219999, 146),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214679, 146),
      ))
    }

@delegate:ResourceContentHash(-1_783_433_148)
internal val Res.string.quiz_sentence_come_traslittera: StringResource by lazy {
      StringResource("string:quiz_sentence_come_traslittera", "quiz_sentence_come_traslittera", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231494, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228770, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229405, 102),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220146, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214826, 86),
      ))
    }

@delegate:ResourceContentHash(-906_584_409)
internal val Res.string.quiz_show_options_button: StringResource by lazy {
      StringResource("string:quiz_show_options_button", "quiz_show_options_button", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231581, 56),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228861, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229508, 60),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220229, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214913, 48),
      ))
    }

@delegate:ResourceContentHash(285_769_569)
internal val Res.string.quiz_solution_prefix: StringResource by lazy {
      StringResource("string:quiz_solution_prefix", "quiz_solution_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231638, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228918, 48),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229569, 48),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220282, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 214962, 48),
      ))
    }

@delegate:ResourceContentHash(-1_321_779_341)
internal val Res.string.quiz_spell_word_prompt: StringResource by lazy {
      StringResource("string:quiz_spell_word_prompt", "quiz_spell_word_prompt", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231687, 66),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 228967, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229618, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220331, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215011, 58),
      ))
    }

@delegate:ResourceContentHash(-899_183_945)
internal val Res.string.quiz_transliteration_entered_hint: StringResource by lazy {
      StringResource("string:quiz_transliteration_entered_hint", "quiz_transliteration_entered_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231754, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229034, 157),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229677, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220398, 149),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215070, 149),
      ))
    }

@delegate:ResourceContentHash(108_331_764)
internal val Res.string.quiz_type_image_keyboard: StringResource by lazy {
      StringResource("string:quiz_type_image_keyboard", "quiz_type_image_keyboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231912, 84),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229192, 84),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229823, 88),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220548, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215220, 84),
      ))
    }

@delegate:ResourceContentHash(1_288_341_597)
internal val Res.string.quiz_type_multi_press: StringResource by lazy {
      StringResource("string:quiz_type_multi_press", "quiz_type_multi_press", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 231997, 57),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229277, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229912, 65),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220625, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215305, 57),
      ))
    }

@delegate:ResourceContentHash(-824_665_211)
internal val Res.string.quiz_type_multi_selection: StringResource by lazy {
      StringResource("string:quiz_type_multi_selection", "quiz_type_multi_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232055, 53),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229343, 61),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 229978, 53),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220683, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215363, 53),
      ))
    }

@delegate:ResourceContentHash(1_002_082_964)
internal val Res.string.quiz_type_phonetic_keyboard: StringResource by lazy {
      StringResource("string:quiz_type_phonetic_keyboard", "quiz_type_phonetic_keyboard", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232109, 71),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229405, 67),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230032, 79),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220741, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215417, 71),
      ))
    }

@delegate:ResourceContentHash(-1_943_266_468)
internal val Res.string.quiz_type_single_selection: StringResource by lazy {
      StringResource("string:quiz_type_single_selection", "quiz_type_single_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232181, 54),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229473, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230112, 50),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220805, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215489, 54),
      ))
    }

@delegate:ResourceContentHash(1_474_542_173)
internal val Res.string.quiz_type_text_translation: StringResource by lazy {
      StringResource("string:quiz_type_text_translation", "quiz_type_text_translation", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232236, 58),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229532, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230163, 58),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220860, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215544, 58),
      ))
    }

@delegate:ResourceContentHash(-263_552_300)
internal val Res.string.quiz_type_true_false: StringResource by lazy {
      StringResource("string:quiz_type_true_false", "quiz_type_true_false", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232295, 52),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229591, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230222, 44),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220919, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215603, 48),
      ))
    }

@delegate:ResourceContentHash(-509_643_880)
internal val Res.string.quiz_type_word_selection: StringResource by lazy {
      StringResource("string:quiz_type_word_selection", "quiz_type_word_selection", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232348, 48),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229644, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230267, 56),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 220964, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215652, 56),
      ))
    }

@delegate:ResourceContentHash(1_336_244_451)
internal val Res.string.quiz_type_word_spelling: StringResource by lazy {
      StringResource("string:quiz_type_word_spelling", "quiz_type_word_spelling", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232397, 55),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229701, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230324, 51),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221021, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215709, 51),
      ))
    }

@delegate:ResourceContentHash(-1_706_016_494)
internal val Res.string.quiz_una_definizione_1: StringResource by lazy {
      StringResource("string:quiz_una_definizione_1", "quiz_una_definizione_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232453, 178),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229761, 182),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230376, 182),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221077, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215761, 178),
      ))
    }

@delegate:ResourceContentHash(-1_061_822_216)
internal val Res.string.quiz_una_definizione_2: StringResource by lazy {
      StringResource("string:quiz_una_definizione_2", "quiz_una_definizione_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232632, 150),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 229944, 162),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230559, 138),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221248, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 215940, 142),
      ))
    }

@delegate:ResourceContentHash(1_371_557_099)
internal val Res.string.quiz_una_definizione_3: StringResource by lazy {
      StringResource("string:quiz_una_definizione_3", "quiz_una_definizione_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232783, 154),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230107, 154),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230698, 158),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221411, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216083, 134),
      ))
    }

@delegate:ResourceContentHash(718_558_723)
internal val Res.string.quiz_una_definizione_4: StringResource by lazy {
      StringResource("string:quiz_una_definizione_4", "quiz_una_definizione_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 232938, 182),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230262, 182),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 230857, 186),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221562, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216218, 178),
      ))
    }

@delegate:ResourceContentHash(1_110_081_440)
internal val Res.string.quiz_verbi_intro_1_1: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_1", "quiz_verbi_intro_1_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233121, 144),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230445, 152),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231044, 144),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221741, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216397, 132),
      ))
    }

@delegate:ResourceContentHash(-792_710_229)
internal val Res.string.quiz_verbi_intro_1_2: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_2", "quiz_verbi_intro_1_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233266, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230598, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231189, 132),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 221890, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216530, 112),
      ))
    }

@delegate:ResourceContentHash(1_538_119_233)
internal val Res.string.quiz_verbi_intro_1_3: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_3", "quiz_verbi_intro_1_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233407, 160),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230727, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231322, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222015, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216643, 152),
      ))
    }

@delegate:ResourceContentHash(-1_228_748_839)
internal val Res.string.quiz_verbi_intro_1_4: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_4", "quiz_verbi_intro_1_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233568, 196),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 230884, 184),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231499, 172),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222164, 172),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216796, 172),
      ))
    }

@delegate:ResourceContentHash(-1_833_863_327)
internal val Res.string.quiz_verbi_intro_1_5: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_5", "quiz_verbi_intro_1_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233765, 164),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231069, 168),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231672, 176),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222337, 164),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216969, 148),
      ))
    }

@delegate:ResourceContentHash(1_450_508_202)
internal val Res.string.quiz_verbi_intro_1_6: StringResource by lazy {
      StringResource("string:quiz_verbi_intro_1_6", "quiz_verbi_intro_1_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 233930, 140),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231238, 156),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 231849, 156),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222502, 148),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217118, 136),
      ))
    }

@delegate:ResourceContentHash(-1_360_534_540)
internal val Res.string.quiz_verbi_sostantivati_1: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_1", "quiz_verbi_sostantivati_1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234274, 153),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231570, 153),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232189, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222830, 153),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217422, 141),
      ))
    }

@delegate:ResourceContentHash(1_309_109_575)
internal val Res.string.quiz_verbi_sostantivati_10: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_10", "quiz_verbi_sostantivati_10", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234071, 202),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231395, 174),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232006, 182),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222651, 178),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217255, 166),
      ))
    }

@delegate:ResourceContentHash(-944_382_123)
internal val Res.string.quiz_verbi_sostantivati_2: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_2", "quiz_verbi_sostantivati_2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234428, 209),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231724, 225),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232355, 221),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 222984, 205),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217564, 217),
      ))
    }

@delegate:ResourceContentHash(-1_209_339_377)
internal val Res.string.quiz_verbi_sostantivati_3: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_3", "quiz_verbi_sostantivati_3", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234638, 181),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 231950, 189),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232577, 205),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 223190, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217782, 189),
      ))
    }

@delegate:ResourceContentHash(-1_904_387_374)
internal val Res.string.quiz_verbi_sostantivati_4: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_4", "quiz_verbi_sostantivati_4", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234820, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 232140, 169),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232783, 145),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 223372, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 217972, 153),
      ))
    }

@delegate:ResourceContentHash(-1_122_192_184)
internal val Res.string.quiz_verbi_sostantivati_5: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_5", "quiz_verbi_sostantivati_5", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 234998, 241),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 232310, 209),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 232929, 213),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 223542, 193),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218126, 185),
      ))
    }

@delegate:ResourceContentHash(-1_069_067_982)
internal val Res.string.quiz_verbi_sostantivati_6: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_6", "quiz_verbi_sostantivati_6", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235240, 177),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 232520, 173),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233143, 181),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 223736, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218312, 165),
      ))
    }

@delegate:ResourceContentHash(-2_136_082_024)
internal val Res.string.quiz_verbi_sostantivati_7: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_7", "quiz_verbi_sostantivati_7", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235418, 141),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 232694, 145),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233325, 153),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 223906, 141),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218478, 129),
      ))
    }

@delegate:ResourceContentHash(1_492_250_635)
internal val Res.string.quiz_verbi_sostantivati_8: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_8", "quiz_verbi_sostantivati_8", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235560, 193),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 232840, 177),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233479, 189),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224048, 173),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218608, 169),
      ))
    }

@delegate:ResourceContentHash(-1_624_246_410)
internal val Res.string.quiz_verbi_sostantivati_9: StringResource by lazy {
      StringResource("string:quiz_verbi_sostantivati_9", "quiz_verbi_sostantivati_9", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235754, 125),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233018, 149),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233669, 169),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224222, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218778, 149),
      ))
    }

@delegate:ResourceContentHash(487_647_679)
internal val Res.string.quiz_verbs_quale_amare: StringResource by lazy {
      StringResource("string:quiz_verbs_quale_amare", "quiz_verbs_quale_amare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235880, 86),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233168, 90),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233839, 86),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224380, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 218928, 82),
      ))
    }

@delegate:ResourceContentHash(-1_175_018_045)
internal val Res.string.quiz_verbs_quale_ascoltare: StringResource by lazy {
      StringResource("string:quiz_verbs_quale_ascoltare", "quiz_verbs_quale_ascoltare", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 235967, 90),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233259, 98),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 233926, 94),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224467, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219011, 86),
      ))
    }

@delegate:ResourceContentHash(-1_978_356_417)
internal val Res.string.quiz_verbs_quale_bere: StringResource by lazy {
      StringResource("string:quiz_verbs_quale_bere", "quiz_verbs_quale_bere", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236058, 85),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233358, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234021, 85),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224562, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219098, 81),
      ))
    }

@delegate:ResourceContentHash(1_858_690_163)
internal val Res.string.register_btn: StringResource by lazy {
      StringResource("string:register_btn", "register_btn", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236144, 36),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233448, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234107, 36),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224648, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219180, 32),
      ))
    }

@delegate:ResourceContentHash(1_111_122_448)
internal val Res.string.reminder_exact_alarm_desc: StringResource by lazy {
      StringResource("string:reminder_exact_alarm_desc", "reminder_exact_alarm_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 236181, 157),
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 233485, 161),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 234144, 165),
        ResourceItem(setOf(LanguageQualifier("it"), ), "${MD}values-it/strings.commonMain.cvr", 224685, 157),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 219213, 125),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString22Resources(map: MutableMap<String, StringResource>) {
  map.put("quiz_preposizione_dr_1_opt4", Res.string.quiz_preposizione_dr_1_opt4)
  map.put("quiz_preposizione_dr_2", Res.string.quiz_preposizione_dr_2)
  map.put("quiz_preposizione_dr_2_opt1", Res.string.quiz_preposizione_dr_2_opt1)
  map.put("quiz_preposizione_dr_2_opt2", Res.string.quiz_preposizione_dr_2_opt2)
  map.put("quiz_preposizione_dr_2_opt3", Res.string.quiz_preposizione_dr_2_opt3)
  map.put("quiz_preposizione_dr_2_opt4", Res.string.quiz_preposizione_dr_2_opt4)
  map.put("quiz_preposizione_dr_3", Res.string.quiz_preposizione_dr_3)
  map.put("quiz_preposizione_dr_3_opt1", Res.string.quiz_preposizione_dr_3_opt1)
  map.put("quiz_preposizione_dr_3_opt2", Res.string.quiz_preposizione_dr_3_opt2)
  map.put("quiz_preposizione_dr_3_opt3", Res.string.quiz_preposizione_dr_3_opt3)
  map.put("quiz_preposizione_dr_3_opt4", Res.string.quiz_preposizione_dr_3_opt4)
  map.put("quiz_preposizione_dr_4", Res.string.quiz_preposizione_dr_4)
  map.put("quiz_preposizione_dr_4_opt1", Res.string.quiz_preposizione_dr_4_opt1)
  map.put("quiz_preposizione_dr_4_opt2", Res.string.quiz_preposizione_dr_4_opt2)
  map.put("quiz_preposizione_dr_4_opt3", Res.string.quiz_preposizione_dr_4_opt3)
  map.put("quiz_preposizione_dr_4_opt4", Res.string.quiz_preposizione_dr_4_opt4)
  map.put("quiz_preposizione_hr_1", Res.string.quiz_preposizione_hr_1)
  map.put("quiz_preposizione_hr_1_opt1", Res.string.quiz_preposizione_hr_1_opt1)
  map.put("quiz_preposizione_hr_1_opt2", Res.string.quiz_preposizione_hr_1_opt2)
  map.put("quiz_preposizione_hr_1_opt3", Res.string.quiz_preposizione_hr_1_opt3)
  map.put("quiz_preposizione_hr_1_opt4", Res.string.quiz_preposizione_hr_1_opt4)
  map.put("quiz_preposizione_hr_2", Res.string.quiz_preposizione_hr_2)
  map.put("quiz_preposizione_hr_2_opt1", Res.string.quiz_preposizione_hr_2_opt1)
  map.put("quiz_preposizione_hr_2_opt2", Res.string.quiz_preposizione_hr_2_opt2)
  map.put("quiz_preposizione_hr_2_opt3", Res.string.quiz_preposizione_hr_2_opt3)
  map.put("quiz_preposizione_hr_2_opt4", Res.string.quiz_preposizione_hr_2_opt4)
  map.put("quiz_preposizione_hr_3", Res.string.quiz_preposizione_hr_3)
  map.put("quiz_preposizione_hr_3_opt1", Res.string.quiz_preposizione_hr_3_opt1)
  map.put("quiz_preposizione_hr_3_opt2", Res.string.quiz_preposizione_hr_3_opt2)
  map.put("quiz_preposizione_hr_3_opt3", Res.string.quiz_preposizione_hr_3_opt3)
  map.put("quiz_preposizione_hr_3_opt4", Res.string.quiz_preposizione_hr_3_opt4)
  map.put("quiz_preposizione_hr_4", Res.string.quiz_preposizione_hr_4)
  map.put("quiz_preposizione_hr_4_opt1", Res.string.quiz_preposizione_hr_4_opt1)
  map.put("quiz_preposizione_hr_4_opt2", Res.string.quiz_preposizione_hr_4_opt2)
  map.put("quiz_preposizione_hr_4_opt3", Res.string.quiz_preposizione_hr_4_opt3)
  map.put("quiz_preposizione_hr_4_opt4", Res.string.quiz_preposizione_hr_4_opt4)
  map.put("quiz_preposizione_m_1", Res.string.quiz_preposizione_m_1)
  map.put("quiz_preposizione_m_2", Res.string.quiz_preposizione_m_2)
  map.put("quiz_preposizione_m_3", Res.string.quiz_preposizione_m_3)
  map.put("quiz_preposizione_m_locativa_1", Res.string.quiz_preposizione_m_locativa_1)
  map.put("quiz_preposizione_m_locativa_1_opt1", Res.string.quiz_preposizione_m_locativa_1_opt1)
  map.put("quiz_preposizione_m_locativa_1_opt2", Res.string.quiz_preposizione_m_locativa_1_opt2)
  map.put("quiz_preposizione_m_locativa_1_opt3", Res.string.quiz_preposizione_m_locativa_1_opt3)
  map.put("quiz_preposizione_m_locativa_1_opt4", Res.string.quiz_preposizione_m_locativa_1_opt4)
  map.put("quiz_preposizione_m_locativa_2", Res.string.quiz_preposizione_m_locativa_2)
  map.put("quiz_preposizione_m_locativa_2_opt1", Res.string.quiz_preposizione_m_locativa_2_opt1)
  map.put("quiz_preposizione_m_locativa_2_opt2", Res.string.quiz_preposizione_m_locativa_2_opt2)
  map.put("quiz_preposizione_m_locativa_2_opt3", Res.string.quiz_preposizione_m_locativa_2_opt3)
  map.put("quiz_preposizione_m_locativa_2_opt4", Res.string.quiz_preposizione_m_locativa_2_opt4)
  map.put("quiz_ripasso_cosa_significa_gero", Res.string.quiz_ripasso_cosa_significa_gero)
  map.put("quiz_ripasso_quale_gero_significa", Res.string.quiz_ripasso_quale_gero_significa)
  map.put("quiz_ripasso_significato", Res.string.quiz_ripasso_significato)
  map.put("quiz_ripasso_traslitterazione", Res.string.quiz_ripasso_traslitterazione)
  map.put("quiz_sdm_f_intro_1", Res.string.quiz_sdm_f_intro_1)
  map.put("quiz_sdm_f_intro_2", Res.string.quiz_sdm_f_intro_2)
  map.put("quiz_sdm_f_intro_3", Res.string.quiz_sdm_f_intro_3)
  map.put("quiz_sdm_f_intro_4", Res.string.quiz_sdm_f_intro_4)
  map.put("quiz_sdm_f_intro_5", Res.string.quiz_sdm_f_intro_5)
  map.put("quiz_sdm_f_intro_6", Res.string.quiz_sdm_f_intro_6)
  map.put("quiz_sdm_f_intro_7", Res.string.quiz_sdm_f_intro_7)
  map.put("quiz_sdm_f_intro_8", Res.string.quiz_sdm_f_intro_8)
  map.put("quiz_sentence_come_traslittera", Res.string.quiz_sentence_come_traslittera)
  map.put("quiz_show_options_button", Res.string.quiz_show_options_button)
  map.put("quiz_solution_prefix", Res.string.quiz_solution_prefix)
  map.put("quiz_spell_word_prompt", Res.string.quiz_spell_word_prompt)
  map.put("quiz_transliteration_entered_hint", Res.string.quiz_transliteration_entered_hint)
  map.put("quiz_type_image_keyboard", Res.string.quiz_type_image_keyboard)
  map.put("quiz_type_multi_press", Res.string.quiz_type_multi_press)
  map.put("quiz_type_multi_selection", Res.string.quiz_type_multi_selection)
  map.put("quiz_type_phonetic_keyboard", Res.string.quiz_type_phonetic_keyboard)
  map.put("quiz_type_single_selection", Res.string.quiz_type_single_selection)
  map.put("quiz_type_text_translation", Res.string.quiz_type_text_translation)
  map.put("quiz_type_true_false", Res.string.quiz_type_true_false)
  map.put("quiz_type_word_selection", Res.string.quiz_type_word_selection)
  map.put("quiz_type_word_spelling", Res.string.quiz_type_word_spelling)
  map.put("quiz_una_definizione_1", Res.string.quiz_una_definizione_1)
  map.put("quiz_una_definizione_2", Res.string.quiz_una_definizione_2)
  map.put("quiz_una_definizione_3", Res.string.quiz_una_definizione_3)
  map.put("quiz_una_definizione_4", Res.string.quiz_una_definizione_4)
  map.put("quiz_verbi_intro_1_1", Res.string.quiz_verbi_intro_1_1)
  map.put("quiz_verbi_intro_1_2", Res.string.quiz_verbi_intro_1_2)
  map.put("quiz_verbi_intro_1_3", Res.string.quiz_verbi_intro_1_3)
  map.put("quiz_verbi_intro_1_4", Res.string.quiz_verbi_intro_1_4)
  map.put("quiz_verbi_intro_1_5", Res.string.quiz_verbi_intro_1_5)
  map.put("quiz_verbi_intro_1_6", Res.string.quiz_verbi_intro_1_6)
  map.put("quiz_verbi_sostantivati_1", Res.string.quiz_verbi_sostantivati_1)
  map.put("quiz_verbi_sostantivati_10", Res.string.quiz_verbi_sostantivati_10)
  map.put("quiz_verbi_sostantivati_2", Res.string.quiz_verbi_sostantivati_2)
  map.put("quiz_verbi_sostantivati_3", Res.string.quiz_verbi_sostantivati_3)
  map.put("quiz_verbi_sostantivati_4", Res.string.quiz_verbi_sostantivati_4)
  map.put("quiz_verbi_sostantivati_5", Res.string.quiz_verbi_sostantivati_5)
  map.put("quiz_verbi_sostantivati_6", Res.string.quiz_verbi_sostantivati_6)
  map.put("quiz_verbi_sostantivati_7", Res.string.quiz_verbi_sostantivati_7)
  map.put("quiz_verbi_sostantivati_8", Res.string.quiz_verbi_sostantivati_8)
  map.put("quiz_verbi_sostantivati_9", Res.string.quiz_verbi_sostantivati_9)
  map.put("quiz_verbs_quale_amare", Res.string.quiz_verbs_quale_amare)
  map.put("quiz_verbs_quale_ascoltare", Res.string.quiz_verbs_quale_ascoltare)
  map.put("quiz_verbs_quale_bere", Res.string.quiz_verbs_quale_bere)
  map.put("register_btn", Res.string.register_btn)
  map.put("reminder_exact_alarm_desc", Res.string.reminder_exact_alarm_desc)
}
